import React, { useContext } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import InvoiceListLayer from "../components/InvoiceListLayer";
import { ConfigContext } from "../context/GlobalContext";
import { Languages } from "../Utils/Languages";
import ProformaInvoiceListLayer from "../components/ProformaInvoiceListLayer";


const ProformaInvoiceListPage = () => {

  const { state } = useContext(ConfigContext);

  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Proforma Invoice - List" />

        {/* InvoiceListLayer */}
        <ProformaInvoiceListLayer businessData={state?.BUSINESSES} invoiceData={state?.PROFORMAINVOICES}/>

      </MasterLayout>

    </>
  );
};

export default ProformaInvoiceListPage;
